export const tablet = 769;
export const desktop = 1024;
export const widescreen = 1216;
export const fullhd = 1441;
export const ultrahd = 1920;

export enum DragType {
  NodeDragButton = "node-drag-button",
  CustomField = "custom-field",
}

export type DragItem = {
  id: string;
  index: number;
};

export const pageVariants = {
  initial: {
    opacity: 0,
  },
  in: {
    opacity: 1,
  },
  out: {
    opacity: 0,
  },
};

export const pageTransition = {
  type: "tween",
  ease: "linear",
  duration: 0.5,
};

export type Holiday = {
  value: string;
  label: string;
};

export const holidays: Holiday[] = [
  { value: "new-years-day", label: "New Year's Day" },
  { value: "martin-luther-king-jr-day", label: "Martin Luther King Jr. Day" },
  { value: "washingtons-birthday", label: "Washington's Birthday" },
  { value: "memorial-day", label: "Memorial Day" },
  {
    value: "juneteenth-national-independence-day",
    label: "Juneteenth National Independence Day",
  },
  { value: "independence-day", label: "Independence Day" },
  { value: "labor-day", label: "Labor Day" },
  { value: "columbus-day", label: "Columbus Day" },
  { value: "veterans-day", label: "Veterans Day" },
  { value: "thanksgiving-day", label: "Thanksgiving Day" },
  { value: "christmas-day", label: "Christmas Day" },
];

export const defaultItemsPerPage = 25;
